/* 
*   TODO: 
*       Create a toasty alert to Bloqueado Judicialmente -
        atualmente o retorno do usuário está como Email ou senha incorreta.
*/

import { defineStore } from 'pinia';
import { useCookie } from '#app';
import ApiService from '~/services/ApiService';
import { useAlert } from '~/stores/alert';
import { useDepositStore } from '~/stores/deposit';
import { useCouponStore } from '~/stores/coupon';
import { useBonusStore } from '~/stores/bonus';
import { useFavoriteGameStore } from '~/stores/favorite-games';
import useFavorite from '@composables/favorite/useFavorite';
import { useTrackingStore } from "@stores/tracking";
import consola from 'consola';

export const useAuthStore = defineStore('auth', () => {
  const currentField = ref('login');
  const { showAlert } = useAlert();
  const depositStore = useDepositStore();
  const couponStore = useCouponStore();
  const bonusStore = useBonusStore();
  const favoriteGameStore = useFavoriteGameStore();
  const { clearFavorites } = useFavorite();

  /** @type {import('@/stores/tracking').TrackingStore} */
  const trackingStore = useTrackingStore();

  const state = reactive({
    displayModal: false,
    isLoggedIn: false,
    user: null,
    userIp: null,
    bonus: 0
  });

  const isUserDocumentModalOpen = ref(false);

  const balance = reactive({
    value: 0,
    bonus: 0
  });

  const activeRollover = ref();

  const balanceAmount = () => {
    return balance.value + balance.bonus / 100;
  };

  const getUserIp = async () => {
    try {
      const response = await $fetch('/v2/get-ip');
      if (response) {
        state.userIp = response.userIP;
      }

    } catch (error) {
      console.error('Error fetching IP:', error);
    }
  };

  const setBalance = (value) => {
    balance.value = value / 100;
  };

  const setLoggedIn = (value) => {
    state.isLoggedIn = value;

    if (!value) {
      if (useCookie('jwt').value) {
        logout();
      }

      const jwtCookie = useCookie('jwt');
      jwtCookie.value = '';
      state.user = null;

      return navigateTo('/');
    }
  };

  const modalOpen = function (openOn) {
    switch (openOn) {
      case 'login':
      case 'register':
      case 'recover':
      case 'close':
        currentField.value = openOn;
        break;
      default:
        currentField.value = 'register';
    }

    state.displayModal = true;
  };

  const modalClose = function () {
    state.displayModal = false;
  };

  const form = ref({
    register: {
      name: '',
      document: '',
      email: '',
      phone: '',
      phone_code: '55',
      birthday: '',
      password: '',
      termsAccepted: false,
      referer: ''
    },
    login: {
      email: '',
      password: '',
      login: ''
    },
    recover: {
      email: ''
    }
  });

  const formErrors = ref({
    register: {
      name: '',
      document: '',
      email: '',
      phone: '',
      phone_code: '',
      birthday: '',
      password: '',
      termsAccepted: false,
      referer: ''
    },
    login: {}
  });

  var token = ref({
    accessToken: '',
    expiresIn: ''
  });

  const getSportBookToken = async () => {
    try {
      const jwtToken = useCookie('jwt').value;

      if (!jwtToken) {
        return null;
      }

      if (!state.user) {
        await getUser();

        if (!isLoggedIn.value || !state.user) {
          return null;
        }
      }
      const { data } = await ApiService.get('/api/generate-token');
      return data.token;
    } catch (error) {
      console.error('Error getting sport book token:', error);
      showAlert('error', 'Erro ao obter token de acesso ao SportBook');
      return null;
    }
  };

  const validateDocument = async () => {
    formErrors.value.register.document = '';

    if (!form.value.register.document) {
      form.value.register.birthday = '';
      form.value.register.name = '';
    }

    try {
      const { data } = await ApiService.post('/api/validate/document', {
        document: form.value.register.document
      });

      if(data?.success === false) {
        formErrors.value.register.document = data.errors;
        form.value.register.birthday = '';
        form.value.register.name = '';
        showAlert('error', data.errors);
        return
      }

      if (data.name) {
        form.value.register.birthday = data.birthday;
        form.value.register.name = data.name;
      } else {
        form.value.register.birthday = '';
        form.value.register.name = '';
        // Set the error message in formErrors
        formErrors.value.register.document = data.message;

        showAlert('error', data.message);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      formErrors.value.register.document = errorMessage;
      showAlert('error', errorMessage);

      // Clear form fields on error
      form.value.register.birthday = '';
      form.value.register.name = '';
    }
  };

  const resetDocumentValidation = () => {
    formErrors.value.register.document = '';
    form.value.register.birthday = '';
    form.value.register.name = '';
  };

  /**
   * Registration System
   *
   */
  const register = async (captchaToken = null) => {
    try {
      const response = await $fetch('/v2/auth/register', {
        method: 'POST',
        body: {
          ...form.value.register,
          password_confirmation: form.value.register.password,
          email_confirmation: form.value.register.email,
          ...(useCookie('referrer_id').value && {
            referrer_id: useCookie('referrer_id').value
          }),
          ...(useCookie('src').value && { src: useCookie('src').value }),
          ...(useCookie('utm_source').value && {
            utm_source: useCookie('utm_source').value
          }),
          ...(useCookie('utm_campaign').value && {
            utm_campaign: useCookie('utm_campaign').value
          }),
          ...(useCookie('utm_content').value && {
            utm_content: useCookie('utm_content').value
          }),
          ...(useCookie('btag').value && { btag: useCookie('btag').value }),
          ...(useCookie('code').value && {
            coupon_code: useCookie('code').value
          }),
          ...(useCookie('_fbc').value && {
            fbc: useCookie('_fbc').value
          }),
          ...(useCookie('_fbp').value && {
            fbp: useCookie('_fbp').value
          }),
          ...(useCookie('afp').value && {
            afp: useCookie('afp').value
          }),
          ...(useCookie('afp1').value && {
            afp1: useCookie('afp1').value
          }),
          ...(useCookie('afp2').value && {
            afp2: useCookie('afp2').value
          }),
          ...(useCookie('afp3').value && {
            afp3: useCookie('afp3').value
          }),
          afp4: useCookie('afp4').value,
          ...(useCookie('afp4').value && {}),
          ...(useCookie('afp5').value && {
            afp5: useCookie('afp5').value
          }),
          ...(useCookie('afp6').value && {
            afp6: useCookie('afp6').value
          }),
          afp7: useCookie('afp7').value,
          ...(useCookie('afp7').value && {}),
          ...(useCookie('afp8').value && {
            afp8: useCookie('afp8').value
          }),
          ...(useCookie('afp9').value && {
            afp9: useCookie('afp9').value
          }),
          ...(useCookie('shareCode').value && {
            shareCode: useCookie('shareCode').value
          }),
          ...(useCookie('source_id').value && {
            source_id: useCookie('source_id').value
          }),
          ...(useCookie('event_id').value && {
            event_id: useCookie('event_id').value
          }),
          ...(useCookie('campaign_id').value && {
            campaign_id: useCookie('campaign_id').value
          }),
          ...(useCookie('utm_medium').value && {
            utm_medium: useCookie('utm_medium').value
          }),
          ...(useCookie('client_id').value && {
            client_id: useCookie('client_id').value
          }),
          ...(useCookie('gclid').value && {
            gclid: useCookie('gclid').value
          }),
          ...(useCookie('subid').value && {
            subid: useCookie('subid').value
          }),
          token: captchaToken
        }
      });

      if (!response.success) {
        if (response.data) {
          Object.entries(response.data.errors).forEach(([key, value]) => {
            const updateValue = (obj) => {
              Object.entries(obj).forEach(([k, v]) => {
                if (k === key.split('.')[1]) {
                  console.log(
                    value.map(([key, value]) => {
                      value;
                    })
                  );
                  // TODO: Need to be a array of strings
                  console.log(value);
                  obj[k] = value;
                } else if (typeof v === 'object' && v !== null) {
                  updateValue(v);
                }
              });
            };
            updateValue(formErrors.value);
          });

          throw new Error(response.data.message);
        } else {
          formErrors.value.register = response.errors;
          throw new Error(response.message);
        }
      } else {
        form.value.login.email = form.value.register.email;
        form.value.login.password = form.value.register.password;
        form.value.login.login = form.value.register.email;
        await login();
        // Removing coupon code after register
        useCookie('code').value = '';

        // Here we send the sign_up event
        await trackingStore.actions.sendEvent('sign_up', {
          birthday: state.user.birthday,
          gender: state.user.gender === 0 ? 'female' : state.user.gender === 1 && 'male',
          ...(useCookie('source_id').value && { source_id: useCookie('source_id').value }),
          ...(useCookie('event_id').value && { event_id: useCookie('event_id').value }),
          ...(useCookie('campaign_id').value && { campaign_id: useCookie('campaign_id').value }),
          ...(useCookie('referrer_id').value && { referrer_id: useCookie('referrer_id').value }),
        })

      }
    } catch (error) {
      console.log('REGISTER: ', error);
      throw error;
    }
  };

  const login = async (email, password) => {
    try {
      await getUserIp();
      const response = await ApiService.post('/api/auth/login', {
        email: form.value.login.email,
        password: form.value.login.password,
        login: form.value.login.login
      });

      // Check for error responses first
      if (response.status === 403) {
        throw new Error(response.data.error || 'Acesso negado');
      }

      // Check for successful login with access token
      if (response.data.access_token) {
        modalClose();

        await setToken(response.data);
        await getUser();

        setLoggedIn(true);

        if (useCookie('jwt').value) {
          await couponStore.getCoupons();
          await bonusStore.getRollovers();
        }

        const hasApprovedTransaction = await ApiService.get(
          '/api/transactions?source=Deposit&type=1&status=2'
        );

        // Open deposit modal if user has coupon code with deposit requirement
        if (useCookie('code').value) {
          const coupon = await couponStore.applyCouponCode(useCookie('code').value);
          if (coupon?.coupon?.deposit) {
            depositStore.toggleModal();
          }
        }
        // Open deposit modal if user has no approved transactions
        else if (!hasApprovedTransaction.data.data.length && !useCookie('code').value) {
          depositStore.toggleModal();
        }

        // Get favorite games
        favoriteGameStore.getFavorites();
      } else {
        formErrors.value.login = response.data.errors;
        throw new Error(response.data.error || 'Email ou senha incorretos!');
      }
    } catch (error) {
      // Pass through the error message
      throw error;
    }
  };

  const logout = async () => {
    websocketStore.cleanupWebsocket();
    try {
      const { data } = await ApiService.post('/api/auth/logout');

      // CORREÇÃO: Limpeza completa de recursos
      // Removing coupon code
      useCookie('code').value = '';
      favoriteGameStore.clearFavorites();
      clearFavorites();
      depositStore.closeModal();
      
      // Limpar dados do usuário e estado
      state.user = null;
      state.isLoggedIn = false;
      balance.value = 0;
      balance.bonus = 0;
      activeRollover.value = {};
      
      // Limpar token
      token.value.accessToken = '';
      token.value.expiresIn = '';
      
    } catch (error) {
      //throw error;
    }
  };

  const getUser = async () => {
    return ApiService.get('/api/auth/me')
      .then(({ data }) => {
        if (data.message == 'Unauthenticated.') {
          setLoggedIn(false);
          return;
        }
        // Setting bonus wallet
        if (data.user_rollover) {
          balance.bonus = data.user_rollover.amount_current;

          activeRollover.value = data.user_rollover;
        } else {
          balance.bonus = 0;
          activeRollover.value = {};
        }

        if (data?.wallet) {
          state.bonus = data.wallet.bonus_mixed;
        }

        setBalance(data.balance);
        state.user = data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          setLoggedIn(false);
        }
        //throw error;
      });
  };

  const setToken = async function (response) {
    token.value.accessToken = response.access_token;
    token.value.expiresIn = response.expires_in;
    let balance = parseJwt(response.access_token).balance;
    let userId = parseJwt(response.access_token).user_id;

    const expirationInMilliseconds = response.expires_in * 1000;
    const expirationDate = new Date(Date.now() + expirationInMilliseconds);

    const jwtCookie = useCookie('jwt', {
      expires: expirationDate,
      sameSite: 'none',
      secure: true
    });
    const balanceCookie = useCookie('balance', {
      expires: expirationDate,
      sameSite: 'none',
      secure: true
    });
    const userIdCookie = useCookie('user_id', {
      expires: expirationDate,
      sameSite: 'none',
      secure: true
    });

    console.log('Setting JWT', jwtCookie);

    jwtCookie.value = token.value.accessToken;
    balanceCookie.value = balance;
    userIdCookie.value = userId;

    setBalance(balance);
  };

  const base64urlToBase64 = (base64url) => {
    base64url = base64url.replace(/-/g, '+').replace(/_/g, '/');

    switch (base64url.length % 4) {
      case 2:
        base64url += '==';
        break;
      case 3:
        base64url += '=';
        break;
    }

    return base64url;
  };

  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(base64urlToBase64(token.split('.')[1])));
    } catch (e) {
      return null;
    }
  };

  const isLoggedIn = computed(() => {
    return state.isLoggedIn;
  });

  const user = computed(() => {
    return state.user;
  });

  function toggleUserDocumentModal() {
    isUserDocumentModalOpen.value = !isUserDocumentModalOpen.value;
  }

  return {
    state,
    modalOpen,
    modalClose,
    getUser,
    form,
    formErrors,
    getUserIp,
    register,
    getSportBookToken,
    setLoggedIn,
    user,
    setBalance,
    login,
    currentField,
    balance,
    isLoggedIn,
    balanceAmount,
    activeRollover,
    isUserDocumentModalOpen,
    toggleUserDocumentModal,
    validateDocument,
    resetDocumentValidation
  };
});
